// ============================================================
// Mock Leave Requests
// ============================================================
import { subDays, format } from 'date-fns';

const today = new Date();

export const mockLeaveRequests = [
  {
    id: 'LV-2026-001',
    teacherId: 'teacher-1',
    teacherName: 'Rajesh Sharma',
    employeeId: 'EMP-GV-001',
    schoolId: 'school-1',
    schoolName: 'Green Valley School',
    leaveType: 'Medical Leave',
    startDate: format(subDays(today, 2), 'yyyy-MM-dd'),
    endDate: format(today, 'yyyy-MM-dd'),
    totalDays: 3,
    reason: 'Fever and cold',
    status: 'Approved',
    appliedDate: format(subDays(today, 5), 'yyyy-MM-dd'),
    approvedBy: 'Admin User',
    approvedDate: format(subDays(today, 4), 'yyyy-MM-dd'),
    adminRemarks: 'Take care, get well soon.',
    attachment: true,
  },
  {
    id: 'LV-2026-002',
    teacherId: 'teacher-2',
    teacherName: 'Priya Patel',
    employeeId: 'EMP-GV-002',
    schoolId: 'school-1',
    schoolName: 'Green Valley School',
    leaveType: 'Casual Leave',
    startDate: format(today, 'yyyy-MM-dd'),
    endDate: format(today, 'yyyy-MM-dd'),
    totalDays: 1,
    reason: 'Personal work',
    status: 'Pending',
    appliedDate: format(subDays(today, 1), 'yyyy-MM-dd'),
    approvedBy: null,
    approvedDate: null,
    adminRemarks: null,
    attachment: false,
  },
  {
    id: 'LV-2026-003',
    teacherId: 'teacher-3',
    teacherName: 'Amit Kumar',
    employeeId: 'EMP-GV-003',
    schoolId: 'school-1',
    schoolName: 'Green Valley School',
    leaveType: 'Emergency Leave',
    startDate: format(subDays(today, 10), 'yyyy-MM-dd'),
    endDate: format(subDays(today, 9), 'yyyy-MM-dd'),
    totalDays: 2,
    reason: 'Family emergency',
    status: 'Rejected',
    appliedDate: format(subDays(today, 12), 'yyyy-MM-dd'),
    approvedBy: 'Admin User',
    approvedDate: format(subDays(today, 11), 'yyyy-MM-dd'),
    adminRemarks: 'Too many staff on leave on this date.',
    attachment: false,
  },
];

export const mockLeaveSummary = {
  pending: 1,
  approvedToday: 1,
  rejectedToday: 1,
  recentRequests: 3,
};

export const mockTeacherLeaveSummary = {
  pending: 1,
  approved: 1,
  rejected: 0,
  balance: 14,
};
